
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBeaconGeneralSquare as ObiBeaconGeneralSquareElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-beacon-general-square.js';
 
 
 

 
 export const ObiBeaconGeneralSquare = createComponent({
   react: React,
   tagName: 'obi-beacon-general-square',
   elementClass: ObiBeaconGeneralSquareElement,
   events: {
     
   }
  });
 
 